module.exports = __webpack_public_path__ + "img/logo-sm-dark.99f2ebdd.png";